// TODO: move to util and reuse in overlay component.
export const createCustomEventObject = ({ name, el, detail = {}, handler }) => ({
  el,
  name,
  event: new CustomEvent(name, {
    bubbles: true,
    detail
  }),
  handler: (e) => {
    // console.log(`${name} listener`, detail, e)
    handler(e);
  },
});

export const createEventToken = (capiid, newskey) => {
  const now = Date.now();
  const diff = (now - (now % (1000 * 60 * 60 * 24) ));
  const rounded = new Date(diff).toISOString();
  const token = window.btoa(`${ rounded }_${ capiid }_${ newskey }`);
  // console.log('token', `${rounded}_${capiid}_${newskey}`, token, diff)

  return token;
};
